import React, { useMemo } from 'react';
import SegmentedPolylineOverlay from './SegmentedPolylineOverlay';

const colorMap = {
  'Initialising': '#1976d2',      
  'Idle': '#fbc02d',  
  'Error': '#f57c00',  
  'Running': '#008000',
  'PowerDown': '#00897b',
  'Maintenance': '#c2185b',
  'Hold': '#800000',
  'Sleep': '#7b1fa2',
  'Flushing': '#bfba2b',
};

// List of all possible modes in preferred order
const allModes = [
  'Initialising',
  'Idle',
  'Error',
  'Running',
  'PowerDown',
  'Maintenance',
  'Hold',
  'Sleep',
  'Flushing'
];

// Add Weed-It Off as the first range if needed
function getRangesWithOff(allPoints, uniqueModes) {
  const hasOff = allPoints.some(pt => pt.weedItOff);
  // Only include modes that appear in the data, but always use the fixed color and display name
  const modeRanges = allModes
    .filter(mode => uniqueModes.includes(mode))
    .map(mode => ({
      min: mode,
      max: mode,
      color: colorMap[mode],
      value: mode,
    }));
  if (hasOff) {
    return [
      {
        min: 'off',
        max: 'off',
        color: '#d32f2f',
        value: 'Weed-It Off',
        dashed: true,
      },
      ...modeRanges
    ];
  }
  return modeRanges;
}

export default function WeedItStatusOverlay({ routes }) {
  // routes: array of segments (arrays of points)
  const allPoints = useMemo(() => routes.flat(), [routes]);
  // Get all unique, non-empty PWM mode values from the route
  const uniqueValues = useMemo(() => {
    const set = new Set();
    allPoints.forEach(pt => {
      if (pt.weedItStatus && typeof pt.weedItStatus === 'string') {
        set.add(pt.weedItStatus);
      }
    });
    return Array.from(set);
  }, [allPoints]);

  const finalRanges = useMemo(() => getRangesWithOff(allPoints, uniqueValues), [allPoints, uniqueValues]);

  // If weedItOff is true, treat as "off" (value 'off')
  const valueSelector = pt =>
    pt.weedItOff ? 'off' : pt.weedItStatus;

  // Legend formatter for display name
  const legendFormatter = r => r.value;

  if (!allPoints.length) return null;

  return (
    <SegmentedPolylineOverlay
      segments={routes}
      valueSelector={valueSelector}
      ranges={finalRanges}
      legendTitle="Status"
      legendFormatter={legendFormatter}
      units=""
      discrete={true}
    />
  );
}